export default __webpack_public_path__ + "static/Elemental-online-barcelona-e312639ae290468d0ef1035b68e07ced.svg";